import { createFileRoute } from "@tanstack/react-router";
import { SettingsSurface } from "../workspace/settings/SettingsSurface";

export const Route = createFileRoute("/settings/")({
  component: SettingsIndexRoute
});

function SettingsIndexRoute() {
  const search = Route.useSearch();
  return <SettingsSurface activeFrameRecordId={search.frame ?? null} activeSection="account" />;
}
